import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=37a224d4&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a224d4",
  null
  
)

export default component.exports